import axios from 'axios';
import { UrlApi } from "../../UrlApi/UrlApi";
// const axios = require('axios');
let TestnewToken = '';
let TestOTP = '123456';
export const TestgenerateToken = async (ipAddress, username) => {
    // const randomOTP = Math.floor(Math.random() * 100000) + 100000;
    // TestOTP = randomOTP.toString();
    const res = await axios.post(UrlApi + "send-notification", { "otp": TestOTP, "ip_address": ipAddress, "user": username });
};

export const TestverifyOTP = async (OTP) => {
    try {
        if (OTP !== TestOTP) {
            console.log('Incorrect OTP');
            throw new Error('รหัส OTP ไม่ถูกต้อง');
        }
        return 'สำเร็จ';
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const TestgetNewToken = () => {
    return TestnewToken;
};
